import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {IUser} from "../../store/sliceUser";
import {deleteUser, fetchAllUsers, fetchRoles, fetchUser, updateUser} from "../../fetch/RequestAdmin";
import {FormGroup} from "../../modal/modalPerson/ModalPersonStyle";
import {Button, Col, Form} from "react-bootstrap";
import Select, {MultiValue} from "react-select";
import {Option} from "react-multi-select-component";
import {useDispatch} from "react-redux";
import {actions} from "../../store/sliceModal";

const AdminTab: FC = (props) => {

    const dispatch = useDispatch();

    const [allUsers, setAllUsers] = useState<IUser[]>([])
    const [user, setUser] = useState<IUser>({} as IUser)
    const [roles, setRoles] = useState<string[]>([])
    const [password, setPassword] = useState<string>('')
    const [userRoles, setUserRoles] = useState<MultiValue<Option>>([]);
    const [f2Auth, setF2Auth] = useState<boolean>(false);

    useEffect(() => {
        fetchAllUsers().then(response => {
            if (response.isSuccess) {
                setAllUsers(response.data)
            }
        })
        fetchRoles().then(response => {
            if (response.isSuccess) {
                setRoles(response.data)
            }
        })
    }, [])

    const options = (users: IUser[]): Option[] => {
        return users.map(user => {
            return {
                label: user.login,
                value: user.email
            } as Option
        })
    }

    const onSelect = useCallback((select: Option) => {
        const user = allUsers.filter(user => user.login === select.label)[0]
        if (user == undefined) {
            return
        }
        fetchUser(user.id).then(response => {
            if (response.isSuccess) {
                setUser(response.data)
                setUserRoles(response.data.roles.map((role: string) => {
                    return {label: role, value: role} as Option
                }))
                setF2Auth(response.data.f2Auth)
            }
        })

    }, [allUsers, setUser])

    const onSave = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        user.f2Auth = f2Auth
        const response = password.length > 0 ? updateUser(user, password) : updateUser(user)
        response.then(resp => {
            if (resp.status === 200) {
                dispatch(actions.showSuccess("Данные успешно обновлены!"))
            }
        })

    }, [user, password, f2Auth])

    const onDelete = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        deleteUser(user.id).then(resp => {
            if (resp.status === 204) {
                setAllUsers(allUsers.filter(u => u.id !== user.id));
                dispatch(actions.showSuccess(`Пользователь ${user.login} успешно удален`))
                setUser({} as IUser)
            }
        })

    }, [user, allUsers])

    const onChange = useCallback(() => {
        user.f2Auth = !user.f2Auth
        setF2Auth(user.f2Auth)
        setUser(user)
    }, [user])

    return (
        <>
            <Select
                id={'main select'}
                isMulti={false}
                onChange={(newValue, actionMeta) => onSelect(newValue as Option)}
                options={options(allUsers)}
                placeholder={''}
                value={user.id ? {label: user.login, value: user.login} as Option : null}
            />

            {user?.id && <>
                <FormGroup as={Col} style={{marginTop: "10px"}}>
                    <Form.Label>Имя</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Имя"
                        value={user.name}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => {
                            user.name = event.target.value
                            setUser(user)
                        }}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Логин</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Логин"
                        value={user.login}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => {
                            user.login = event.target.value
                            setUser(user)
                        }}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="email"
                        value={user.email}
                        // isValid={name.isValid}
                        // isInvalid={name.isInvalid}
                        onChange={(event) => {
                            user.email = event.target.value
                            setUser(user)
                        }}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Роли</Form.Label>
                    <Select
                        isMulti
                        onChange={(newValue, actionMeta) => {
                            setUserRoles(newValue)
                            user.roles = newValue.map(value => value.label)
                            setUser(user)
                        }}
                        options={roles?.map(role => {
                            return {label: role, value: role} as Option
                        })}
                        value={userRoles}
                        noOptionsMessage={({inputValue}) => null}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Label>Пароль</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Пароль"
                        value={password}
                        onChange={(event) => {
                            setPassword(event.target.value)
                        }}
                    />
                </FormGroup>
                <FormGroup as={Col}>
                    <Form.Check style={{marginRight: "5px"}}
                                id="switch"
                                label="Присылать код на email при авторизации"
                                onChange={onChange}
                                checked={f2Auth}
                    />
                </FormGroup>
                <Button variant={"outline-success"}
                        onClick={onSave}
                        style={{marginTop: "20px", marginRight: "10px"}}
                >
                    Обновить
                </Button>
                <Button variant={"outline-danger"}
                        onClick={onDelete}
                        style={{marginTop: "20px"}}
                >
                    Удалить
                </Button>
            </>

            }
        </>
    )
}
export default AdminTab
